import { Grid, Typography } from "@mui/material"
import type { orderItem as OrderItemType } from './VerificationType'

type configType = {
  script: string,
  voice_person?: string,
  voice_talent: string,
  voice_tone: string,
}

const labelStyle = { color: '#7A97B0', fontSize: '14px!important', fontWeight: 400 }
const valueStyle = { fontWeight: 500, fontSize: '14px!important', color: '#242424' }

const ProfessionalRecordingConfig = ({ orderItem }: { orderItem: OrderItemType }) => {
  const config: configType = orderItem.config

  return <Grid container spacing={1.5}>
    <Grid item sm={4}>
      <Typography sx={labelStyle}>Voice talent</Typography>
      <Typography sx={valueStyle}>{config.voice_talent}</Typography>
    </Grid>
    <Grid item sm={4}>
      <Typography sx={labelStyle}>Voice tone</Typography>
      <Typography sx={valueStyle}>{config.voice_tone}</Typography>
    </Grid>
    <Grid item sm={4}>
      <Typography sx={labelStyle}>Voice person</Typography>
      <Typography sx={valueStyle}>{config.voice_person ?? '-'}</Typography>
    </Grid>
    <Grid item sm={12}>
      <Typography sx={labelStyle}>Script</Typography>
      <Typography sx={valueStyle}>{config.script}</Typography>
    </Grid>
  </Grid>
}

export default ProfessionalRecordingConfig
